import { combineReducers } from 'redux';
import { AdminUserPagination } from './AdminUserPagination.reducer';
import { alert } from './alert.reducer';
import authentication from './authentication.reducer';
import { Calculation } from './Calculation.reducer';
import { Cart } from './CartItems.reducer';
import { DistributorList } from './DistributorList.reducer';
import { offerData } from './OfferData.reducer';
import { ViewOffer } from './OfferDetails.reducer';
import { OrderData } from './OrderDetails.reducer';
import { FilterData } from './ProductFilters.reducer';
import { Products } from './Products.reducer';
import { Profile } from './profile.reducer';
import { UsersList } from './userslist.reducer';
import { wishList } from './Wishlist.reducer';
import { ViewBulkOffer } from './BulkOfferDetails.reducer';

const rootReducer = combineReducers({
    alert,
    authentication,
    UsersList,
    AdminUserPagination,
    DistributorList,
    Profile,
    Products,
    FilterData,
    wishList,
    Cart,
    Calculation,
    ViewOffer,
    offerData,
    OrderData,
    ViewBulkOffer
});
export default rootReducer;
